/**
 * Asset and in-app URL helpers for Electron (file:// + HashRouter) and web.
 */

const isElectron = () =>
  typeof window !== 'undefined' && !!window.electronAPI?.isElectron;

/** CRA public folder asset (works with PUBLIC_URL=. in packaged Electron). */
export function getPublicAssetUrl(relativePath = '') {
  const clean = String(relativePath || '').replace(/^\/+/, '');
  const base = process.env.PUBLIC_URL || '';
  if (!base) return `/${clean}`;
  const prefix = base.endsWith('/') ? base : `${base}/`;
  return `${prefix}${clean}`;
}

/** file:///.../index.html (no hash) — base for in-app hash routes in Electron. */
export function getElectronAppFileBase() {
  if (typeof window === 'undefined') return '';
  const href = window.location.href;
  const hashIdx = href.indexOf('#');
  return hashIdx >= 0 ? href.slice(0, hashIdx) : href;
}

/** Public QR menu route loaded inside the app (iframe preview on dashboard). */
export function getQrMenuPublicUrl(publicUrl) {
  if (!publicUrl) return null;
  const slug = String(publicUrl).replace(/^\/+/, '');

  if (isElectron()) {
    return `${getElectronAppFileBase()}#/qr-menu/${slug}`;
  }

  const origin = window.location.origin;
  if (!origin || origin === 'null') {
    return `${getElectronAppFileBase()}#/qr-menu/${slug}`;
  }

  return `${origin}/qr-menu/${slug}`;
}

/** Hosted web URL for "open in browser" links (optional REACT_APP_WEB_URL). */
export function getHostedWebOrigin() {
  const fromEnv =
    process.env.REACT_APP_WEB_URL ||
    process.env.REACT_APP_PUBLIC_WEB_URL ||
    '';
  if (fromEnv) return String(fromEnv).replace(/\/$/, '');
  return null;
}

export function getQrMenuExternalUrl(publicUrl) {
  if (!publicUrl) return null;
  const hosted = getHostedWebOrigin();
  if (hosted) return `${hosted}/qr-menu/${String(publicUrl).replace(/^\/+/, '')}`;
  if (isElectron()) return null;
  return getQrMenuPublicUrl(publicUrl);
}

/** Authenticated embed route for template previews inside PhoneFrame iframes. */
export function getQrMenuEmbedUrl(qrMenuId, templateId) {
  if (!qrMenuId || !templateId) return null;
  const path = `/qr-menu/${qrMenuId}/embed/${templateId}`;

  if (isElectron()) {
    return `${getElectronAppFileBase()}#${path}`;
  }

  const origin = window.location.origin;
  if (!origin || origin === 'null') {
    return `${getElectronAppFileBase()}#${path}`;
  }

  return `${origin}${path}`;
}
